// The virtual keyboard of phones only shrinks the visual viewport (interactive-widget=resizes-visual
// in the pages viewport meta): window.innerHeight keeps the height without it.
// Sets the class keyboard_open and the css variable --keyboard_height on <html>,
// and calls onOpen when the keyboard opens.

const keyboardMinHeightRatio = 0.25


function hiddenHeight (viewport) {
    return window.innerHeight - viewport.height * viewport.scale
}


function isKeyboardOpen (viewport) {
    return hiddenHeight(viewport) > keyboardMinHeightRatio * window.innerHeight
}


export default function watchVirtualKeyboard (onOpen) {
    const viewport = window.visualViewport
    if (!viewport) {
        return
    }

    let wasOpen = false

    viewport.addEventListener('resize', () => {
        const open = isKeyboardOpen(viewport)
        document.documentElement.classList.toggle('keyboard_open', open)
        document.documentElement.style.setProperty('--keyboard_height', (open ? hiddenHeight(viewport) : 0) + 'px')
        if (open && !wasOpen) {
            onOpen(viewport)
        }
        wasOpen = open
    })
}
